import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import BtnStandardIconText from "../../../ds/BtnStandardIconText/BtnStandardIconText";
import { useContent, useLanguages } from "../../../hooks/content";
import { Returntext } from "../../../pages/Landings/common/returnText";
import openLeaderboard from "../../../hooks/leaderboard";

const LeaderboardBtn = ({ txt: customTxt }) => {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onPageShow = (event) => {
      if (event.persisted) setLoading(false);
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  const txt =
    customTxt ||
    Returntext(contentManagementData, "navbar_leaderboard", lang) ||
    (lang === "en" ? "Leaderboard" : "ლიდერბორდი");

  const handleClick = async () => {
    setLoading(true);
    try {
      await openLeaderboard();
    } catch (err) {
      console.log("Leaderboard error:", err);
      enqueueSnackbar(
        lang === "en"
          ? "Leaderboard is unavailable, please try again later"
          : "ლიდერბორდი დროებით მიუწვდომელია, სცადეთ მოგვიანებით",
        { variant: "error" }
      );
      setLoading(false);
    }
  };

  return (
    <BtnStandardIconText
      mode=""
      mainColor={"green"}
      txt={txt}
      disabled={loading}
      size={"standard"}
      icon={false}
      onClick={handleClick}
    />
  );
};

export default LeaderboardBtn;
